// extracted by mini-css-extract-plugin
module.exports = {"affixMenuWrap":"affixMenu_affixMenuWrap__-tDMh","menuItem":"affixMenu_menuItem__3UwPG"};